import { toSafeInternalPath } from './internal-path';

export const RETURN_URL_STORAGE_KEY = 'gws-audit-log:oauth-return-url';

export function saveOAuthReturnUrl(url: string): void {
  sessionStorage.setItem(RETURN_URL_STORAGE_KEY, url);
}

/**
 * sessionStorage に保存された OAuth 戻り先 URL を取得する。
 * 読み出し後は sessionStorage から key を削除し、stale な値を残さない。
 * Open Redirect 防御は `toSafeInternalPath` に委譲する。
 */
export function resolveOAuthReturnUrl(): string | null {
  const value = sessionStorage.getItem(RETURN_URL_STORAGE_KEY);
  if (!value) return null;
  sessionStorage.removeItem(RETURN_URL_STORAGE_KEY);
  return toSafeInternalPath(value);
}
